<ng-container *ngIf="withPrefix" [ngTemplateOutlet]="content"></ng-container>
<mat-form-field appearance="outline" [ngClass]="appClass"
                class="max-width {{ (validations.valid && !max) ? 'no-hint' : 'responsive-hint' }}
                                 {{ !validations.valid || requiredButEmpty ? 'field-error' : '' }}
                                 {{ withSuffix ? 'with-suffix' : '' }}
                                 {{ withPrefix ? 'with-prefix' : '' }}
                                 {{ isTextarea ? 'mdc-textarea' : '' }}
                                 {{ small ? 'small' : '' }}"
                (focusin)="utilService.mobileFocus($event.target)">
  <mat-label *ngIf="label">
    {{ label | translate }}<span *ngIf="required" class="mat-mdc-form-field-required-marker mdc-floating-label--required"></span>
  </mat-label>
  <input matInput *ngIf="!isTextarea" [type]="isEmail ? 'email' : 'text'" [name]="name" [placeholder]="placeholder"
         [(ngModel)]="value" [ngModelOptions]="{standalone: true}"
         (blur)="isInputTouched = true"
         (keyup)="inputKeyup.emit($event)"
         (paste)="isInputDirty = true"
         [maxlength]="max ? (max + 10) : null" [disabled]="disabled" autocomplete="off">
  <textarea matInput *ngIf="isTextarea" [name]="name"
            (keyup)="inputKeyup.emit($event)"
            (paste)="isInputDirty = true"
            (blur)="isInputTouched = true"
            [(ngModel)]="value" [ngModelOptions]="{standalone: true}"
            [cdkTextareaAutosize]="true" [cdkAutosizeMinRows]="minRows" [cdkAutosizeMaxRows]="maxRows" [readonly]="readonly"
            [maxlength]="max ? (max + 10) : null" [disabled]="disabled"></textarea>
  <mat-hint class="text-muted" [ngClass]="{'flex max-width': max, 'space-between': max && (!validations.valid || hint?.length), 'flex-end': max && validations.valid && !hint?.length}"
            *ngIf="!hideHints && (hint?.length || !validations.valid || max)">
    <span *ngIf="validations.valid && hint?.length">
      <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
      {{ hint | translate }}
    </span>
    <span class="text-warning" *ngIf="!validations.valid">
      <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
      <ng-container *ngIf="hasCustomError">{{ customError | translate }}</ng-container>
      <ng-container *ngIf="!hasCustomError">
        <ng-container *ngIf="!errorMessage">
          {{ (validations.tooLong ? 'general.api_validation_text_too_long' :
             (validations.tooShort ? 'general.api_validation_text_too_short' :
             (validations.emailInvalid ? 'general.api_validation_email_invalid' :
             (validations.linkInvalid ? 'general.api_validation_link_invalid' : 'general.api_validation_text_invalid')))) | translate: {minLength: min, maxLength: max} }}
        </ng-container>
        <ng-container *ngIf="errorMessage">{{ errorMessage | translate: {minLength: min, maxLength: max} }}</ng-container>
      </ng-container>
    </span>
    <span [ngClass]="{'text-warning': !validations.valid}" *ngIf="max">
      {{ (value?.length || 0) }}/{{ max }}
    </span>
  </mat-hint>
</mat-form-field>
<ng-container *ngIf="withSuffix" [ngTemplateOutlet]="content"></ng-container>
<ng-template #content><ng-content></ng-content></ng-template>
